var map = {
	"./Akita Set psd 1.jpg": 2025,
	"./American Vibe Set psd 1.jpg": 1462,
	"./Boston Set psd 1.jpg": 54,
	"./California Dream Set psd 1.jpg": 2747,
	"./Dallas Set psd 1.jpg": 7606,
	"./Florida Set psd 1.jpg": 735,
	"./Hungry Guys Set.jpg": 7962,
	"./Katana Set.jpg": 8919,
	"./Los Angeles psd 1.jpg": 7218,
	"./Maki Vibes Set psd 1.jpg": 3890,
	"./Miami Set psd 1.jpg": 2431,
	"./New York Set psd 1.jpg": 82,
	"./Osaka Set.jpg": 7725,
	"./Saitama Set.jpg": 1038,
	"./Sushi Mania psd 1.jpg": 6038,
	"./Texas psd 1.jpg": 9464,
	"./Tokyo Vip set psd 1.jpg": 9493,
	"./Veggie Set psd 1.jpg": 5579,
	"./Washington Vip psd 1.jpg": 4185,
	"./Yakitoriya Set psd 1.jpg": 6416,
	"./Yummy Set psd 1.jpg": 1267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2162;